var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C13.1768 0 13.3464 0.0702379 13.4714 0.195262C13.5964 0.320286 13.6666 0.489856 13.6666 0.666667V11.3333C13.6666 11.5101 13.5964 11.6797 13.4714 11.8047C13.3464 11.9298 13.1768 12 13 12H0.99998C0.823169 12 0.653599 11.9298 0.528575 11.8047C0.403551 11.6797 0.333313 11.5101 0.333313 11.3333V0.666667C0.333313 0.489856 0.403551 0.320286 0.528575 0.195262C0.653599 0.0702379 0.823169 0 0.99998 0H13ZM12.3333 1.33333H1.66665V10.6667H12.3333V1.33333ZM5.26598 3.33333L7.39865 8.66667H5.96198L5.69531 8H3.50198L3.23531 8.66667H1.79931L3.93265 3.33333H5.26598ZM11.6666 3.33333V8.66667H9.66665C9.13621 8.66667 8.62751 8.45595 8.25243 8.08088C7.87736 7.70581 7.66665 7.1971 7.66665 6.66667C7.66665 6.13623 7.87736 5.62753 8.25243 5.25245C8.62751 4.87738 9.13621 4.66667 9.66665 4.66667H10.3326L10.3333 3.33333H11.6666ZM10.3333 6H9.66665C9.49673 6.00019 9.33329 6.06525 9.20973 6.1819C9.08618 6.29854 9.01182 6.45797 9.00187 6.6276C8.99191 6.79722 9.0471 6.96425 9.15616 7.09455C9.26522 7.22486 9.41992 7.3086 9.58865 7.32867L9.66665 7.33333H10.3333V6ZM4.59931 5.25667L4.03465 6.66667H5.16265L4.59931 5.25667Z",
    fill: "#1B407A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAd);
export default __webpack_public_path__ + "static/media/ad.384c5e7129b4132f948e19fc7edaaa59.svg";
export { ForwardRef as ReactComponent };